import {scholarshipProgramHighSchoolsConfig} from 'src/views/college-portal/scholarship-program-high-schools';
import {deleteCampaignConfig} from 'src/views/college-portal/delete-campaign-modal';

export const cpModals = [deleteCampaignConfig, scholarshipProgramHighSchoolsConfig];
